import React from 'react';
import ECGWorkstationManagement from '../components/ECGWorkstationManagement';

const ECGWorkstationManagementPage = () => {
  return (
    <ECGWorkstationManagement />
  );
};

export default ECGWorkstationManagementPage;
